import { render } from "./PaginationTextComponent.vue?vue&type=template&id=9ee20042"
import script from "./PaginationTextComponent.vue?vue&type=script&lang=js"
export * from "./PaginationTextComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/components/PaginationTextComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ee20042"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ee20042', __exports__)) {
    api.reload('9ee20042', __exports__)
  }
  
  module.hot.accept("./PaginationTextComponent.vue?vue&type=template&id=9ee20042", () => {
    api.rerender('9ee20042', render)
  })

}


export default __exports__